{
  "public.detail": {
    "search.placeholder": "搜索名单",
    "hero.shortlistBy": "入围名单 {{name}}",
    "empty.title": "无人入围",
    "empty.description": "通过选择要呈现给利益相关者的资源来构建您的候选列表",
    "filters.label": "筛选",
    "item.emptyValue": "无",
    "passwordProtection": {
      "enterPassword": "输入密码以查看候选名单",
      "placeholder": "输入密码",
      "viewShortlist": "查看候选名单"
    },
    "error": {
      "title": "搜索候选名单时出错"
    }
  },
  "GridViewItemGallery": {
    "editGallery": "编辑图库",
    "emptyGalleryTitle": "空图库",
    "emptyGalleryDescription": "为此资源添加媒体",
    "addMedia": "添加媒体"
  },
  "ShortlistVotes": {
    "upvote": "赞成",
    "downvote": "反对",
    "saveFailed": "无法保存您的投票。请重试。"
  },
  "GenericSearchFilterItem": {
    "filters": {
      "belongsToMe": "属于我",
      "createdAt": "创建于 {{date}} 之后",
      "publishedOnly": "仅已发布",
      "draftOnly": "仅草稿",
      "archived": "显示已归档",
      "contactId": "资源 {{contact}}",
      "between": "介于 {{startDate}} - {{endDate}} 之间",
      "tags": {
        "and": " 和 ",
        "more": " 更多",
        "any": "任意标签: {{tag}}",
        "match": "匹配标签: {{tags}}"
      }
    }
  },
  "ShortlistMediaSidebarPage": {
    "draft": "草稿",
    "votingDisabled": "候选名单未公布时禁止投票",
    "commentingDisabled": "候选名单未公布时禁止评论",
    "votingAndCommentingDisabled": "未发布时禁用投票和评论"
  },
  "MediaSidebar": {
    "Header": {
      "shortlistedCount": "已入围 {{count}} / {{totalBlocks}}",
      "previous": "上一位入围者",
      "next": "下一位入围者"
    },
    "CommentList": {
      "label": "评论",
      "guest": "访客",
      "noComments": "还没有评论",
      "startConversation": "来说说你对{{name}}的看法吧。",
      "startConversationNoName": "与团队分享你对此人的看法。",
      "commentsOff": "评论已关闭"
    },
    "CommentInput": {
      "writeComment": "写评论",
      "addComment": "添加评论",
      "writeFirstComment": "写下第一条评论",
      "sendFailed": "无法发送您的评论。请重试。"
    },
    "GuestNameChangeForm": {
      "title": "访客反馈",
      "description": "在下方输入您的姓名以留下反馈",
      "placeholder": "您的姓名",
      "saveChanges": "保存更改"
    },
    "GuestInfo": {
      "youAre": "您是 {{name}}",
      "change": "更改"
    },
    "Details": {
      "noFields": "此候选名单没有可显示的字段"
    },
    "Tabs": {
      "label": "分区",
      "comments": "评论",
      "details": "详情"
    }
  },
  "SetGuestNameModal": {
    "title": "设置访客名称",
    "description": "在投票或评论入围者之前，您需要告诉入围者您的身份",
    "yourName": "您的姓名",
    "saveName": "保存名称",
    "successfullyCreated": "创建成功",
    "guestNameSet": "访客名称已设置"
  },
  "ShortlistCreateButton": {
    "create": "创建候选名单"
  },
  "ShortlistCreateDialog": {
    "title": "创建候选名单",
    "description": "为新的候选名单命名、添加描述和标签。",
    "titleLabel": "标题",
    "titlePlaceholder": "候选名单标题",
    "titleRequired": "请输入标题",
    "descriptionLabel": "描述",
    "descriptionPlaceholder": "客户会在标题下方看到",
    "tagsLabel": "标签",
    "create": "创建"
  }
}
